const getEmptyFields = (obj, prefix, errorObj) => {
  const result = {};

  Object.keys(errorObj).forEach((key) => {
    const val = obj[key];

    let isEmpty = false;

    // 1. Empty string, null, undefined
    if (val === null || val === undefined || val === "") {
      isEmpty = true;
    }

    // 2. Empty array
    else if (Array.isArray(val) && val.length === 0) {
      isEmpty = true;
    }

    // 3. Invalid dates
    else if (key.toLowerCase().includes("date")) {
      const d = new Date(val);
      if (isNaN(d.getTime())) {
        isEmpty = true;
      }
    }

    // 4. Empty object {}
    else if (typeof val === "object" && !Array.isArray(val)) {
      // File object detection: File or Blob
      if (val instanceof File) {
        isEmpty = val.size === 0;
      }
      // FileList (from input type="file")
      else if (val instanceof FileList) {
        isEmpty = val.length === 0;
      }
      // Directus file object (expecting id)
      else if (!val.id) {
        isEmpty = true;
      } else if ("id" in val && !val.id) {
        isEmpty = true;
      }

      // Check if empty object {}
      else if (Object.keys(val).length === 0) {
        isEmpty = true;
      }
    }

    if (isEmpty) {
      result[`${key}${prefix ? `-${prefix}` : ""}`] = true;
    }
  });

  return result;
};
export default getEmptyFields;
